import { FormField, Text, Input, Button } from '@wix/design-system';
import React, { useContext, useState } from 'react';
import ReactPlayer from 'react-player';
import { RicosContext, EditorContext, PluginsEventsContext } from 'ricos-context';
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI, generateId } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { EMBED_TAB_URL_INPUT, EMBED_TAB_SUBMIT_BUTTON } from '../dataHooks.js';
import { isSoundcloudUrl } from './utils.js';
import { AUDIO_TYPE } from 'ricos-content';

var css_248z = ".er36k{--wds-input-value-font-size-medium:14px}";
var classes = {"input":"er36k"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AudioEmbed = ({
  componentData,
  fetchData,
  closeModal,
  nodeId
}) => {
  var _a, _b;
  const { t } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const [url, setUrl] = useState(((_b = (_a = componentData == null ? void 0 : componentData.audio) == null ? void 0 : _a.src) == null ? void 0 : _b.url) || "");
  const [submittedInvalidUrl, setSubmittedInvalidUrl] = useState(false);
  const onEmbedClick = async () => {
    var _a2;
    (_a2 = pluginsEvents.publishPluginPopoverClick) == null ? void 0 : _a2.call(pluginsEvents, {
      pluginId: AUDIO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
    });
    const _b2 = componentData, rest = __objRest(_b2, ["audio", "name", "coverImage", "authorName", "disableDownload"]);
    if (isSoundcloudUrl(url)) {
      await fetchAndEmbedAudio(url, rest);
    } else if (ReactPlayer.canPlay(url)) {
      updateRicosDocument({ audio: { src: { url } } });
      closeModal();
    } else {
      await fetchAndEmbedAudio(url, rest);
    }
  };
  const fetchAndEmbedAudio = async (url2, data) => {
    try {
      const { html } = await (fetchData == null ? void 0 : fetchData(url2)) || {};
      if (html) {
        updateRicosDocument(__spreadProps(__spreadValues({}, data), { audio: { src: { url: url2 } }, html }));
        closeModal();
      } else {
        setSubmittedInvalidUrl(true);
      }
    } catch (e) {
      setSubmittedInvalidUrl(true);
    }
  };
  const updateRicosDocument = (audio) => queueMicrotask(
    () => nodeId ? getEditorCommands().setBlock(nodeId, AUDIO_TYPE, audio) : getEditorCommands().insertBlockWithBlankLines(AUDIO_TYPE, __spreadProps(__spreadValues({}, audio), { id: generateId() }))
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormField,
    {
      label: /* @__PURE__ */ React.createElement(Text, { size: "tiny", weight: "thin" }, t("AudioModal_Embed_Title"))
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        className: classes.input,
        type: "url",
        autocomplete: "off",
        dataHook: EMBED_TAB_URL_INPUT,
        value: url,
        onChange: (e) => {
          if (submittedInvalidUrl) {
            setSubmittedInvalidUrl(false);
          }
          setUrl(e.target.value);
        },
        status: submittedInvalidUrl ? "error" : void 0,
        statusMessage: submittedInvalidUrl ? t("SoundCloudUploadModal_Input_InvalidUrl") : void 0,
        placeholder: t("EmbedURL_Placeholder")
      }
    )
  ), /* @__PURE__ */ React.createElement(Button, { dataHook: EMBED_TAB_SUBMIT_BUTTON, onClick: onEmbedClick }, t("AudioModal_Embed_ButtonText")));
};

export { AudioEmbed };
//# sourceMappingURL=audio-embed.js.map
